import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import AccountLanding from "../views/AccountLanding"
import PurchasedAccess from "../views/PurchasedAccess"
import OrderHistory from "../views/OrderHistory"

export default function Account() {

  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  async function init() {
    const nextView = getView();
    if (nextView) {
      setView(nextView);
    }
  }

  function getView() {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <AccountLanding />
    }

    if (!appContext.auth) {
      return <AccountLanding />
    }

    if (
      appContext.navSubItem === 'purchased-access' &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <PurchasedAccess />
    }

    if (
      appContext.navSubItem === 'order-history' &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <OrderHistory />
    }

    return null;
  }

  useEffect(() => {
    init();
  }, [appContext.auth, appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem])

  return view;
}
